/**
 * @name menuConfig
 * @author Gabriel M. Guimarães | gabrielmg7
 * @description Definição centralizada da estrutura do menu lateral para responsáveis.
 * @package src/components/layouts/UserLayout/components/UserSideBar/menuConfig.ts
 **/

import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HistoryIcon from '@mui/icons-material/History';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import { MenuItem } from './types';

export const menuConfig: MenuItem[] = [
     {
          key: 'home',
          text: 'Dashboard',
          icon: <DashboardIcon />,
          path: '/',
     },
     {
          key: 'saldo',
          text: 'Carteira',
          icon: <AccountBalanceWalletIcon />,
          path: '/creditos',
     },
     {
          key: 'dependentes',
          text: 'Meus Dependentes',
          icon: <PeopleIcon />,
          path: '/dependentes',
     },
     {
          key: 'historico-compras',
          text: 'Histórico de Compras',
          icon: <HistoryIcon />,
          path: '/historico-compras',
     },
     {
          key: 'configuracoes',
          text: 'Configurações',
          icon: <SettingsIcon />,
          children: [
               {
                    key: 'minha-conta',
                    text: 'Minha Conta',
                    icon: <PersonIcon />,
                    path: '/minha-conta',
               },
          ],
     },
];
